/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ early_bird_discount_percent: NonNullable<unknown> }} Subscription_Discount_Promotion_CnInputs */

const en_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const ar_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const de_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const es_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const fr_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const it_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const ja_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const ko_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const pt_br_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const ru_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const th_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const tr_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer! Save ${i?.early_bird_discount_percent}% now!`)
};

const zh_cn_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`早鸟特惠中！现在购买省 ${i?.early_bird_discount_percent}%`)
};

const zh_tw_subscription_discount_promotion_cn = /** @type {(inputs: Subscription_Discount_Promotion_CnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`早鸟特惠中！现在购买省 ${i?.early_bird_discount_percent}%`)
};

/**
* | output |
* | --- |
* | "Early Bird Offer! Save {early_bird_discount_percent}% now!" |
*
* @param {Subscription_Discount_Promotion_CnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_discount_promotion_cn = /** @type {((inputs: Subscription_Discount_Promotion_CnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Discount_Promotion_CnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_discount_promotion_cn(inputs)
	if (locale === "ar") return ar_subscription_discount_promotion_cn(inputs)
	if (locale === "de") return de_subscription_discount_promotion_cn(inputs)
	if (locale === "es") return es_subscription_discount_promotion_cn(inputs)
	if (locale === "fr") return fr_subscription_discount_promotion_cn(inputs)
	if (locale === "it") return it_subscription_discount_promotion_cn(inputs)
	if (locale === "ja") return ja_subscription_discount_promotion_cn(inputs)
	if (locale === "ko") return ko_subscription_discount_promotion_cn(inputs)
	if (locale === "pt_br") return pt_br_subscription_discount_promotion_cn(inputs)
	if (locale === "ru") return ru_subscription_discount_promotion_cn(inputs)
	if (locale === "th") return th_subscription_discount_promotion_cn(inputs)
	if (locale === "tr") return tr_subscription_discount_promotion_cn(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_discount_promotion_cn(inputs)
	return zh_tw_subscription_discount_promotion_cn(inputs)
});